import React, { useState, useEffect } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import { MdOutlineDashboard, MdPayments } from "react-icons/md";
import { TbReportAnalytics, TbReportSearch } from "react-icons/tb";
import { BiSolidPurchaseTagAlt, BiSolidPurchaseTag } from "react-icons/bi";
import { AiOutlineUser, AiFillCloseCircle } from "react-icons/ai";
import { FiShoppingCart } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import { FaMoneyCheckDollar, FaBoxOpen, FaProductHunt, FaRegCreditCard, FaNoteSticky, FaAngleDown, FaArrowRight } from "react-icons/fa6";
import { LiaCoinsSolid } from "react-icons/lia";
import "./sidenavscroll.css"
import Logout from "./Logout";
import { useAuth } from "../../AuthContext";
import { FaDollarSign } from "react-icons/fa";

const SideNav = () => {
  const { userRole, currentUser } = useAuth()
  const [employee, setEmployee] = useState(true);

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])
  const menus = [
    { name: "Dashboard", link: "/dashboard", icon: MdOutlineDashboard },
    {
      name: "Accounts",
      icon: AiOutlineUser,
      submenus: [
        { name: "Salesman", link: "salesman", icon: AiOutlineUser },
        { name: "Clients", link: "clients", icon: AiOutlineUser },
        { name: "Vendors", link: "vendors", icon: AiOutlineUser },
      ],
    },
    {
      name: "Sales",
      icon: FaDollarSign,
      submenus: [
        { name: "Sales Return", link: "sales_return", icon: AiOutlineUser },
        { name: "Sales Quotation", link: "sales_qoutation", icon: AiOutlineUser },
        { name: "Sales Invoices", link: "invoices", icon: TbReportAnalytics, margin: true },
        { name: "Delivery Notes", link: "delivery-notes", icon: FaNoteSticky },
      ],
    },
    {
      name: "Purchases",
      icon: BiSolidPurchaseTag,
      submenus: [
        { name: "Purchase Order", link: "purchase_order", icon: AiOutlineUser },
        { name: "Purchase/Expense", link: "purchases", icon: BiSolidPurchaseTagAlt },
        { name: "Purchase Return", link: "purchase_return", icon: BiSolidPurchaseTagAlt },
      ],
    },
    {
      name: "Payments",
      icon: MdPayments,
      submenus: [
        { name: "Vendor Payments", link: "vendor_payments", icon: FaMoneyCheckDollar },
        { name: "Client Receiving", link: "client_payments", icon: FaMoneyCheckDollar },
      ],
    },
    {
      name: "Items/Products",
      icon: FaBoxOpen,
      submenus: [
        { name: "Item & Services", link: "item-services", icon: FiShoppingCart },
        { name: "Bundled Products", link: "products", icon: FaProductHunt },
        { name: "Manage Categories", link: "item-category", icon: FaProductHunt },
      ],
    },
    {
      name: "Credit & Debit",
      icon: FaRegCreditCard,
      submenus: [
        { name: "Credit Note", link: "credit_note", icon: FiShoppingCart },
        { name: "Debit Note", link: "debit_note", icon: FaProductHunt },
      ],
    },

    { name: "Damage Control", link: "damagecontrol", icon: AiFillCloseCircle },
    { name: "Cheques", link: "cheques", icon: LiaCoinsSolid },
    {
      name: "Reports",
      icon: TbReportSearch,
      submenus: [
        { name: "Damage Reports", link: "damage_reports", icon: TbReportSearch },
        { name: "Sales Reports", link: "sales_reports", icon: TbReportSearch },
        { name: "Item Sales Report", link: "item_sales", icon: TbReportSearch },
        { name: "Inventory Reports", link: "inventory_reports", icon: TbReportSearch },
        { name: "Payment Reports", link: "payments_report", icon: TbReportSearch },
        { name: "Purchase/Expense Reports", link: "purchase_expense_reports", icon: TbReportSearch },
        // { name: "Item/Product Reports", link: "item_p_reports", icon: TbReportSearch },
        { name: "Client Accounts", link: "client_accounts", icon: AiOutlineUser },
        { name: "Vendor Accounts", link: "vendor_accounts", icon: AiOutlineUser },
      ],
    },
  ];

  // State to manage the open/closed state of the side navigation
  const [open, setOpen] = useState(true);
  const [subMenuOpenStates, setSubMenuOpenStates] = useState(Array(menus.length).fill(false));

  const toggleSubMenu = (index) => {
    const updatedSubMenuOpenStates = subMenuOpenStates.map((state, i) => i === index ? !state : false);
    setSubMenuOpenStates(updatedSubMenuOpenStates);
  };

  // Get the current location using the useLocation hook
  const location = useLocation();
  const cleanPathname = location.pathname.replace('/dashboard/', '');

  // Function to update the `open` state based on screen width
  const updateScreenSize = () => {
    if (window.innerWidth <= 768) { // Adjust the breakpoint as needed
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  // Call the `updateScreenSize` function when the component mounts and on window resize
  useEffect(() => {
    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  return (
    <section className="flex relative">
      <div
        className={` bg-white min-h-screen shadow-md overflow-y-auto  custom-scrollbar flex flex-col justify-between ${open ? " w-64" : " w-[75px]"
          } duration-500 text-gray-100 px-[10px]  py-1 sm:py-2 md:py-2 lg:py-2 xl:py-2 2xl:py-2`}
      >
        <div className=" flex flex-col gap-2">
          <div className={`py-1 flex ${!open ? "justify-center":"justify-end"}`}>
            {/* {open && (
            <h2 className="text-2xl text-black font-poppins hidden md:block">Dashboard</h2>
          )} */}
            <HiMenuAlt3
              size={26}
              className="cursor-pointer text-[#2F80ED]"
              onClick={() => setOpen(!open)}
            />
          </div>
          <div className="pt-3 flex flex-col gap-2 relative max-h-[1200px] overflow-y-auto overflow-x-hidden">
            {menus?.map((menu, i) => (
              <Link
                to={menu?.link}
                key={i}
                title={menu.name}
                className={`${menu.submenus && "flex flex-col"}`}
              >
                <div
                  onClick={() => {
                    if (menu.submenus) {
                      setOpen(true);
                      toggleSubMenu(i);
                    }
                  }}
                  className={`
                    ${menu?.margin ?? ''}
                    group flex items-center text-base gap-3.5 font-poppins 
                    hover:bg-[#003A75] hover:text-white
                    transition ease-in-out delay-150 hover:-translate-y-1 mb-1
                    ${open ? 'p-2 w-full rounded-md' : 'w-full justify-center p-1 rounded-lg'} 
                    ${(!open && (cleanPathname === menu?.link || (menu?.submenus && menu.submenus.some(submenu => cleanPathname === submenu.link))))
                      ? 'bg-[#003A75] text-white'
                      : 'text-black'
                    }
                    ${cleanPathname === menu?.link ? 'bg-[#003A75] text-white' : 'text-black'}
                  `}
                >
                  <div 
                    className={`
                    p-2 lg:p-2.5 rounded-md
                    ${open ? 'text-[16px] group-hover:bg-white group-hover:text-[#003A75]' : 'text-[20px]'} 
                    ${cleanPathname === menu?.link || (!open && menu?.submenus && menu.submenus.some(submenu => cleanPathname === submenu.link)) 
                      ? 'bg-white text-[#003A75]' 
                      : 'bg-[#007FFF] text-white'}
                    transition ease-in-out delay-150 
                    `}

                  >

                    {React.createElement(menu?.icon)}
                  </div>
                  <h2
                    style={{
                      transitionDelay: `${i + 0.7}00ms`,
                    }}
                    className={`whitespace-pre duration-200 ${!open && "hidden"}`}
                  >
                    {menu?.name}
                  </h2>
                  {menu.submenus && (
                    // Inside the map function for rendering submenus:
                    <div className={`text-[#007FFF] group-hover:text-white w-full flex justify-end cursor-pointer transition delay-75 ${!open && "hidden"}`}>
                      {React.createElement(
                        FaAngleDown,
                        {
                          size: "20",
                          style: {
                            transform: subMenuOpenStates[i] ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.3s ease',
                            transitionDelay: `${i + 0.7}00ms`, // Adjust duration and easing as needed
                          }
                        }
                      )}
                    </div>
                  )}
                </div>


                {menu.submenus && (
                  <div className={`pl-3 flex flex-col gap-1 ${(!open || !subMenuOpenStates[i]) && "hidden"}`}>
                    {menu.submenus.map((submenu, j) => (
                      <Link
                        key={j}
                        to={submenu.link}
                        title={submenu.name}
                        className={`group flex p-2 items-center text-base gap-3.5 font-poppins hover:bg-[#003A75] hover:text-white hover:duration-100 rounded-md ${cleanPathname === (submenu.link) ? "bg-[#003A75] text-white" : "text-black"}`}
                      >
                        <div className={` group-hover:text-white ${cleanPathname === (submenu.link) ? " text-white" : "text-[#007FFF]"} `}>{React.createElement(FaArrowRight, { size: "20" })}</div>
                        <h2>{submenu.name}</h2>
                      </Link>
                    ))}
                  </div>
                )}
                {/* <h2
                className={`${
                  open && "hidden"
                } absolute left-48 bg-white font-poppins whitespace-pre text-gray-900 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit  `}
              >
                {menu?.name}
              </h2> */}
              </Link>
            ))}
          </div>
        </div>
        <div className=" flex flex-col gap-2 mt-3 items-center pt-2 border-t border-gray-500">
          {currentUser && currentUser.email && (
            <p className={`text-xs text-black ${open ? "block" : " hidden"
              }`}>
              Logged in as: <span className="ml-1 text-base font-semibold">{currentUser.email}</span>
            </p>
          )}
          {!employee && currentUser && currentUser.email && (
            <Link
              to="register"
              className={`text-base bg-[#007FFF] font-semibold w-full text-center py-2 text-white rounded-lg ${open ? "block" : " hidden"
                }`}
            >
              Add New Employee
            </Link>
          )}
          <Logout isOpen={open} />
        </div>
      </div>

    </section>
  );
};

export default SideNav;